import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import StoreButtonBase from "../StoreButtonBase";

import { AppStoreButtonProps } from "./AppStoreButton.types";
import { AppStoreLogo, AppStoreText } from "./svgs";

const AppStoreButton: FC<AppStoreButtonProps> = ({ className, ...props }) => {
	const block = new BemIt("AppStoreButton");

	return (
		<StoreButtonBase className={addClass(className).after(block)} {...props}>
			<AppStoreLogo className={block.el("icon").out} />
			<AppStoreText className={block.el("text").out} />
		</StoreButtonBase>
	);
};

export default AppStoreButton;
